
export function getDisplayObjectBounds(obj: createjs.DisplayObject) {
    let bounds: createjs.Rectangle;
    if (obj instanceof createjs.Shape) {
        bounds = obj.graphics.bounds;
    } else {
        bounds = obj.getBounds();
    }
    return bounds ? bounds : new createjs.Rectangle(0, 0, 0, 0);
}
